import { EyeOff } from "lucide-react";

// Shown when an editor/admin previews an unpublished (draft) page.
export default function DraftBanner({ show }) {
  if (!show) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-[80] bg-amber-500 text-ink text-center text-xs md:text-sm font-medium py-2.5 px-4 flex items-center justify-center gap-2" data-testid="draft-banner">
      <EyeOff className="w-4 h-4" />
      Draft preview — this page is not published. Only logged-in editors can see it.
    </div>
  );
}
